"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var util_1 = require("@gooddata/util");
var PreviewRows_1 = tslib_1.__importDefault(require("../shared/PreviewRows"));
var Bubble_1 = require("../../../Bubble");
var Typography_1 = require("../../../Typography");
function templateDropdownItemId(template) {
    return "gd-format-preset-template-" + template.localIdentifier;
}
var DropdownItem = /** @class */ (function (_super) {
    tslib_1.__extends(DropdownItem, _super);
    function DropdownItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            displayHelp: false,
        };
        _this.onClick = function () {
            _this.props.onClick(_this.props.template);
        };
        _this.toggleHelp = function () {
            _this.setState(function (state) { return ({ displayHelp: !state.displayHelp }); });
        };
        return _this;
    }
    DropdownItem.prototype.render = function () {
        var _a = this.props, template = _a.template, separators = _a.separators;
        var displayHelp = this.state.displayHelp;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { id: templateDropdownItemId(template), className: "gd-list-item gd-format-preset gd-format-template s-measure-format-template-" + util_1.stringUtils.simplifyText(template.name), onClick: this.onClick },
                react_1.default.createElement("span", { title: template.name, className: "gd-format-preset-name gd-list-item-shortened" }, template.name),
                react_1.default.createElement("div", { className: "gd-format-template-help gd-icon-circle-question s-measure-format-template-help-toggle-icon", onMouseEnter: this.toggleHelp, onMouseLeave: this.toggleHelp })),
            displayHelp ? (react_1.default.createElement(Bubble_1.Bubble, { alignTo: "#" + templateDropdownItemId(template), className: "gd-measure-format-template-preview-bubble bubble-light s-measure-format-template-help-bubble-" + util_1.stringUtils.simplifyText(template.name), alignPoints: [{ align: "cr cl" }, { align: "cr bl" }, { align: "cr tl" }] },
                react_1.default.createElement(Typography_1.Typography, { className: "gd-measure-format-template-preview-bubble-title", tagName: "h3" }, template.name),
                react_1.default.createElement("div", { className: "gd-measure-format-template-preview-bubble-subtitle s-measure-format-template-help-preview-" + util_1.stringUtils.simplifyText(template.name) },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "measureNumberCustomFormatDialog.template.preview.title" })),
                react_1.default.createElement(PreviewRows_1.default, { previewNumbers: [
                        -1234567.891, -1234.567, -1.234, 0, 1.234, 1234.567, 1234567.891,
                    ], format: template.format, separators: separators }))) : null));
    };
    return DropdownItem;
}(react_1.default.Component));
exports.default = DropdownItem;
//# sourceMappingURL=DropdownItem.js.map